module.exports = "../images/icons-race-details/Location.svg";